var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcomeFlagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 204
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#18314F",
    strokeWidth: 0.5,
    d: "M246.435 187.027c-19.855-44.676-66.588-76.05-121.076-76.05-54.392 0-101.058 31.265-120.971 75.817"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.863,
    cy: 188.307,
    fill: "#7F7F7F",
    fillRule: "nonzero",
    rx: 124.863,
    ry: 15.539
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.289,
    cy: 185.931,
    fill: "#7F7F7F",
    fillRule: "nonzero",
    rx: 14.991,
    ry: 2.559
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M83.729 75.876h4.753V188.49h-4.753z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C72133",
    d: "M98.355 32h61.426v30.347c0 8.078-6.548 14.626-14.626 14.626H83.73V46.625C83.73 38.548 90.277 32 98.355 32z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.936,
    cy: 181.936,
    r: 4.936,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 76,
    r: 8,
    fill: "#18314F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 54.5,
    r: 5.5,
    fill: "#18314F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 107.5,
    r: 3.5,
    fill: "#18314F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 123.5,
    r: 3.5,
    fill: "#18314F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.5,
    cy: 3.5,
    r: 3.5,
    fill: "#18314F"
  }))));
}
export default SvgWelcomeFlagIcon;